var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_12",
    "data-name": "\\u8DEF\\u5F84 12",
    d: "M21,2H1V21H13l.72-5.05L14,14l7-2Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6CE8\\u518C",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2",
    "data-name": "\\u77E9\\u5F62 2",
    width: 7,
    height: 1,
    rx: 0.5,
    transform: "translate(14 17)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_3",
    "data-name": "\\u77E9\\u5F62 3",
    width: 7,
    height: 1,
    rx: 0.5,
    transform: "translate(17 21) rotate(-90)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_2",
    "data-name": "\\u7EC4 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_11",
    "data-name": "\\u8DEF\\u5F84 11",
    d: "M18.61,17.77l-5.22-2.58c-.24-.12-.4-.71-.4-1v-.68a5.54,5.54,0,0,0,3-5A5.27,5.27,0,0,0,11,3,5.27,5.27,0,0,0,6,8.5a5.54,5.54,0,0,0,3,5v.64c0,.26-.18.89-.42,1L3.39,17.77a.67.67,0,0,0-.39.62V19.5a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5V18.39a.67.67,0,0,0-.39-.62Z",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSI+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+CiAgICAgIDxwYXRoIGlkPSLot6/lvoRfMTIiIGRhdGEtbmFtZT0i6Lev5b6EIDEyIiBkPSJNMjEsMkgxVjIxSDEzbC43Mi01LjA1TDE0LDE0bDctMloiIGZpbGw9Im5vbmUiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgogIDxnIGlkPSLms6jlhowiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIC0yKSI+CiAgICA8cmVjdCBpZD0i55+p5b2iXzIiIGRhdGEtbmFtZT0i55+p5b2iIDIiIHdpZHRoPSI3IiBoZWlnaHQ9IjEiIHJ4PSIwLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0IDE3KSIgZmlsbD0iIzUwNTA1MCIvPgogICAgPHJlY3QgaWQ9IuefqeW9ol8zIiBkYXRhLW5hbWU9IuefqeW9oiAzIiB3aWR0aD0iNyIgaGVpZ2h0PSIxIiByeD0iMC41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNyAyMSkgcm90YXRlKC05MCkiIGZpbGw9IiM1MDUwNTAiLz4KICAgIDxnIGlkPSLnu4RfMiIgZGF0YS1uYW1lPSLnu4QgMiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtcGF0aCkiPgogICAgICA8cGF0aCBpZD0i6Lev5b6EXzExIiBkYXRhLW5hbWU9Iui3r+W+hCAxMSIgZD0iTTE4LjYxLDE3Ljc3bC01LjIyLTIuNThjLS4yNC0uMTItLjQtLjcxLS40LTF2LS42OGE1LjU0LDUuNTQsMCwwLDAsMy01QTUuMjcsNS4yNywwLDAsMCwxMSwzLDUuMjcsNS4yNywwLDAsMCw2LDguNWE1LjU0LDUuNTQsMCwwLDAsMyw1di42NGMwLC4yNi0uMTguODktLjQyLDFMMy4zOSwxNy43N2EuNjcuNjcsMCwwLDAtLjM5LjYyVjE5LjVhLjUuNSwwLDAsMCwuNS41aDE1YS41LjUsMCwwLDAsLjUtLjVWMTguMzlhLjY3LjY3LDAsMCwwLS4zOS0uNjJaIiBmaWxsPSJub25lIiBzdHJva2U9IiM1MDUwNTAiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };